var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.popupId,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "deleteLinkModalLabel",
        "aria-hidden": "true"
      }
    },
    [
      _vm.link && _vm.link.id
        ? _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h2", [_vm._v("Delete Link")]),
                _c("button", {
                  ref: "popupCloseButton",
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }
                })
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _c("p", [
                  _vm._v(
                    "\n          Are you sure you want to delete this link?\n          "
                  ),
                  _vm.link.title
                    ? _c("strong", [
                        _vm._v(' "' + _vm._s(_vm.link.title) + '"')
                      ])
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "modal-footer delete-link-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-lg-grey",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn-lg-green btn-delete",
                    attrs: { type: "button", disabled: _vm.busy },
                    on: { click: _vm.deleteLink }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.busy ? "Deleting..." : "Delete") +
                        "\n        "
                    )
                  ]
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }